import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 800px;
  margin: 6rem auto 4rem;
  padding: 2rem;
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 4px 15px rgba(122, 73, 136, 0.1);
`;

const Title = styled.h1`
  color: #7A4988;
  font-size: 2.4rem;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const Subtitle = styled.h2`
  color: #7A4988;
  font-size: 1.6rem;
  margin-bottom: 1rem;
`;

const Text = styled.p`
  color: #555;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

function PrivacyPolicy() {
  return (
    <PageContainer>
      <Title>Privacy Policy</Title>
      
      <Section>
        <Subtitle>Information We Collect</Subtitle>
        <Text>
          We collect personal information you provide (name, email, shipping address, payment 
          details) when you place an order or contact us. We also collect browsing data via 
          cookies to improve your experience.
        </Text>
      </Section>

      <Section>
        <Subtitle>How We Use Your Information</Subtitle>
        <Text>
          Your information is used to process orders, communicate with you, and improve our 
          services. We may send promotional emails (you can opt out anytime).
        </Text>
      </Section>

      <Section>
        <Subtitle>Data Protection</Subtitle>
        <Text>
          We use secure payment processors and encryption to protect your data. However, no 
          online transmission is 100% secure, and we cannot guarantee absolute security.
        </Text>
      </Section>

      <Section>
        <Subtitle>Third Parties</Subtitle>
        <Text>
          We share information with shipping providers and payment processors as necessary. 
          We do not sell your data to third parties for marketing purposes.
        </Text>
      </Section>

      <Section>
        <Subtitle>Your Rights</Subtitle>
        <Text>
          You may request access, correction, or deletion of your personal data by contacting 
          us at <a href="mailto:lavenderandpalmco@gmail.com">lavenderandpalmco@gmail.com</a>.
        </Text>
      </Section>
    </PageContainer>
  );
}

export default PrivacyPolicy;